import { render, staticRenderFns } from "./HelloWorldPage.vue?vue&type=template&id=fe039808&"
import script from "./HelloWorldPage.vue?vue&type=script&lang=js&"
export * from "./HelloWorldPage.vue?vue&type=script&lang=js&"
import style0 from "./HelloWorldPage.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports